import clsx from "clsx";
import type { PropsWithChildren } from "react";

type Props = PropsWithChildren & {
	position?: "top" | "bottom";
}

const SidebarFooter = ({ children, position = "bottom" }: Props) => (
	<div className={clsx("flex justify-end gap-x-2 px-7", position === "bottom" ? "bg-white pb-[calc(1.25rem+env(safe-area-inset-bottom))] pt-5" : "bg-gray-100 pb-2")}
		 style={position === "top" ? undefined : { boxShadow: "0 0 4px 0 rgba(0,0,0,.2)" }}>
		{children}
	</div>
);
export default SidebarFooter;